import React from "react";
// import Footer from "@Components/Footer"
import Notifications from "../../Notifications";
import Header from "./Header";
import styles from "./index.module.scss";
import Pages from "./Pages";
export default class extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.content },
                React.createElement(Header, { hasSupportTel: false }),
                React.createElement("div", { className: styles.blursBackground }),
                React.createElement("div", { className: styles.backgroundDecorative },
                    React.createElement("div", { className: styles.backgroundMask })),
                React.createElement("div", { className: styles.page },
                    React.createElement(Pages, null))),
            React.createElement(Notifications, null)));
    }
}
